require('angular').module('oly.common')
    .directive('wowMask', [require('./mask.directive')]);



// WEBPACK FOOTER //
// ./src/olycommon/mask/index.js